import { Component } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { ProjectsService, ProposalsService, ProposalsPeService } from '../services/projects-proposals-service/projects-proposals.service';
import { ListService } from './services/list.service';
import { saveAs } from 'file-saver';
import { resumeDataInterface } from '../interfaces/resume';

interface IRequestOfRows {
  limit: number;
  skip: number;
  filters: any;
  conds: any;
  ordering: any;
  export: boolean;
}

class BaseSearchComponent {
  //public elementList: Array<any>;
  public elementList: {'offset':0, 'registers':0, 'rows': Array<any>};
  public resumeData: resumeDataInterface = {ambit:{totalEU: 0, totalE: 0, totalInt: 0, totalCAT: 0, numEU: 0, numE: 0, numInt: 0, numCAT: 0},
        empresa:{totalMCRIT: 0, totalMULTI: 0, totalAIEMULTI: 0, totalERSI: 0, totalGEO: 0, numMCRIT: 0, numMULTI: 0, numAIEMULTI: 0, numERSI: 0, numGEO: 0}};

  public sendRows(req: IRequestOfRows){

    this.requestService.getActive(req.limit, req.skip, req.filters, req.conds, req.ordering, (req.export?true:false))
      .subscribe(
        elements => {
          if(!req.export){
            this.elementList = elements;
            this.resumeData = {ambit:{totalEU: 0, totalE: 0, totalInt: 0, totalCAT: 0, numEU: 0, numE: 0, numInt: 0, numCAT: 0},
            empresa:{totalMCRIT: 0, totalMULTI: 0, totalAIEMULTI: 0, totalERSI: 0, totalGEO: 0, numMCRIT: 0, numMULTI: 0, numAIEMULTI: 0, numERSI: 0, numGEO: 0}};
            
            this.elementList.rows.map(item => {
              switch(item.ambit_proposta){
                case 'Europa': this.resumeData.ambit.totalEU+=(item.import_propi?item.import_propi:item.pressupost_contractat);this.resumeData.ambit.numEU++;break;
                case 'Internacional': this.resumeData.ambit.totalInt+=(item.import_propi?item.import_propi:item.pressupost_contractat);this.resumeData.ambit.numInt++;break;
                case 'Espanya': this.resumeData.ambit.totalE+=(item.import_propi?item.import_propi:item.pressupost_contractat);this.resumeData.ambit.numE++;break;
                case 'Catalunya': this.resumeData.ambit.totalCAT+=(item.import_propi?item.import_propi:item.pressupost_contractat);this.resumeData.ambit.numCAT++;break;
              };
              switch(item.empresa){
                case 'MCRIT': this.resumeData.empresa.totalMCRIT+=(item.import_propi?item.import_propi:item.pressupost_contractat);this.resumeData.empresa.numMCRIT++;break;
                case 'Multicriteri': this.resumeData.empresa.totalMULTI+=(item.import_propi?item.import_propi:item.pressupost_contractat);this.resumeData.empresa.numMULTI++;break;
                case 'Multicriteri MCRIT AIE': this.resumeData.empresa.totalAIEMULTI+=(item.import_propi?item.import_propi:item.pressupost_contractat);this.resumeData.empresa.numAIEMULTI++;break;
                case 'Ersília': this.resumeData.empresa.totalERSI+=(item.import_propi?item.import_propi:item.pressupost_contractat);this.resumeData.empresa.numERSI++;break;
                case 'Geovincles': this.resumeData.empresa.totalGEO+=(item.import_propi?item.import_propi:item.pressupost_contractat);this.resumeData.empresa.numGEO++;break;
              }
            });
          }   
          else{
            var file = new Blob(["\ufeff",elements], { type: 'text/csv;charset=utf-8' });
            saveAs(file, "export.csv");
          }},
        error => console.log(error)
      );
  }
  constructor(public translate: TranslateService, public languageService: LanguageService, private requestService: ProjectsService | ProposalsService | ProposalsPeService, private route: ActivatedRoute) {}
}

@Component({
  selector: 'mcrit-gestio-projects-search',
  template: `
    <mcrit-gestio-projects-list
      (requestRows)="sendRows($event)"
      [resumeData]="resumeData"
      [elementList]="elementList">
    </mcrit-gestio-projects-list>`,
  styleUrls: ['projects-search.component.css'],
  providers: [ProjectsService, ProposalsService, ProposalsPeService]
})
export class ProjectsSearchComponent extends BaseSearchComponent {

  constructor(public translate: TranslateService, public languageService: LanguageService, projectsService: ProjectsService, route: ActivatedRoute) {
    super(translate, languageService, projectsService, route);
  }
}

@Component({
  selector: 'mcrit-gestio-proposals-search',
  template: `
    <mcrit-gestio-proposals-list
      (requestRows)="sendRows($event)"
      [resumeData]="resumeData"
      [elementList]="elementList">
    </mcrit-gestio-proposals-list>`,
  styleUrls: ['projects-search.component.css'],
  providers: [ProjectsService, ProposalsService, ProposalsPeService]
})
export class ProposalsSearchComponent extends BaseSearchComponent {

  constructor(public translate: TranslateService, public languageService: LanguageService, proposalsService: ProposalsService, route: ActivatedRoute) {
    super(translate, languageService, proposalsService, route);
  }
}

@Component({
  selector: 'mcrit-gestio-proposalspe-search',
  template: `
    <mcrit-gestio-proposalspe-list
      (requestRows)="sendRows($event)"
      [resumeData]="resumeData"
      [elementList]="elementList">
    </mcrit-gestio-proposalspe-list>`,
  styleUrls: ['projects-search.component.css'],
  providers: [ProjectsService, ProposalsService, ProposalsPeService]
})
export class ProposalsPeSearchComponent extends BaseSearchComponent {

  constructor(public translate: TranslateService, public languageService: LanguageService, preproposalsService: ProposalsPeService, route: ActivatedRoute) {
    super(translate, languageService, preproposalsService, route);
  }
}